import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { feedbackAPI } from '../services/api';
import MyAccount from './Dashboard/MyAccount';
import Campaigns from './Dashboard/Campaigns';
import Characters from './Dashboard/Characters';
import SourceMaterial from './Dashboard/SourceMaterial';
import News from './Dashboard/News';
import AdminPanel from './Dashboard/AdminPanel';
import FeedbackModal from './Dashboard/FeedbackModal';
import './Dashboard/PlayerDashboard.css';

function PlayerDashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('news');
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [feedbackSuccess, setFeedbackSuccess] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleFeedbackSubmit = async (feedbackData) => {
    try {
      await feedbackAPI.submit(feedbackData);
      setFeedbackSuccess(true);
      setTimeout(() => setFeedbackSuccess(false), 3000);
      return Promise.resolve();
    } catch (error) {
      console.error('Error submitting feedback:', error);
      throw new Error(error.response?.data?.error || 'Failed to submit feedback');
    }
  };

  // Check if user is admin
  const isAdmin = user?.role === 'ADMIN';

  return (
    <div className="player-dashboard">
      {/* Header */}
      <header className="dashboard-header">
        <div className="header-content">
          <h1>The Ascended</h1>
          <div className="user-info">
            <button 
              onClick={() => setFeedbackModalOpen(true)}
              className="btn-feedback"
              title="Send Feedback"
            >
              💬 Feedback
            </button>
            <span className="username">
              {user?.username}
              {isAdmin && <span className="admin-badge">ADMIN</span>}
            </span>
            <button onClick={handleLogout} className="btn-logout">
              Logout
            </button>
          </div>
        </div>
      </header>

      {/* Success Message */}
      {feedbackSuccess && (
        <div className="feedback-success-banner">
          ✅ Thank you for your feedback! We've received your message.
        </div>
      )}

      {/* Navigation Tabs */}
      <nav className="dashboard-nav">
        <button
          className={`nav-tab ${activeTab === 'news' ? 'active' : ''}`}
          onClick={() => setActiveTab('news')}
        >
          News & Updates
        </button>
        <button
          className={`nav-tab ${activeTab === 'account' ? 'active' : ''}`}
          onClick={() => setActiveTab('account')}
        >
          My Account
        </button>
        <button
          className={`nav-tab ${activeTab === 'campaigns' ? 'active' : ''}`}
          onClick={() => setActiveTab('campaigns')}
        >
          Campaigns
        </button>
        <button
          className={`nav-tab ${activeTab === 'characters' ? 'active' : ''}`}
          onClick={() => setActiveTab('characters')}
        >
          Characters
        </button>
        <button
          className={`nav-tab ${activeTab === 'source' ? 'active' : ''}`}
          onClick={() => setActiveTab('source')}
        >
          Source Material
        </button>
        
        {/* Admin Panel Tab - Only visible to admins */}
        {isAdmin && (
          <button
            className={`nav-tab admin-tab ${activeTab === 'admin' ? 'active' : ''}`}
            onClick={() => setActiveTab('admin')}
          >
            🛠️ Admin Panel
          </button>
        )}
      </nav>

      {/* Main Content Area */}
      <main className="dashboard-content">
        {activeTab === 'news' && <News />}
        {activeTab === 'account' && <MyAccount user={user} />}
        {activeTab === 'campaigns' && <Campaigns />}
        {activeTab === 'characters' && <Characters />}
        {activeTab === 'source' && <SourceMaterial />}
        {activeTab === 'admin' && isAdmin && <AdminPanel />}
      </main>

      {/* Feedback Modal */}
      <FeedbackModal
        isOpen={feedbackModalOpen}
        onClose={() => setFeedbackModalOpen(false)}
        onSubmit={handleFeedbackSubmit}
      />
    </div>
  );
}

export default PlayerDashboard;
